import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { toast } from '../utils';

export const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Split path and filter out empty segments
  const pathSegments = pathname.split('/').filter(segment => segment !== '');

  // Get the last meaningful segment
  let lastPathSegment = pathSegments[pathSegments.length - 1];
  const firstPathSegment = pathSegments[0];

  // Check if last segment is a parameter (numeric or UUID format)
  const isLastSegmentParam = /^\d+$/.test(lastPathSegment) ||
    /^[0-9a-f]{24}$/i.test(lastPathSegment) || // MongoDB-like ID (24 hex chars)
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(lastPathSegment);

  // If last segment is a parameter, use the previous segment for permission check
  const permissionSegment = isLastSegmentParam && pathSegments.length > 1
    ? pathSegments[pathSegments.length - 2]
    : lastPathSegment;

  const user = JSON.parse(localStorage.getItem('user'));
  const appToken = localStorage.getItem('token');
  const isSuperAdmin = user ? user.superadmin : false;
  const isSuperAdminEnabled = firstPathSegment === user?.redirect;

  // Use permissionSegment instead of lastPathSegment for permission check
  const isUserEnabled =
    user && user.permissions ? user.permissions.some((permission) => permission.includes(permissionSegment)) : false;

  // Function to verify the token using jwt-decode
  const verifyToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      const expiryTime = decoded.exp * 1000; // Convert expiry time to milliseconds
      return Date.now() < expiryTime; // Token is valid if the current time is before expiry
    } catch (error) {
      console.error('Token verification error:', error);
      return false;
    }
  };

  useEffect(() => {
    // Check if both tokens are present and valid
    const userTokenIsValid = user && verifyToken(user.token);
    const appTokenIsValid = appToken && verifyToken(appToken);

    if (!userTokenIsValid) {
      localStorage.clear();
      // toast(`🚫 Oops! Your Session Has Been Expire. Please contact support for help! 😕`, { variant: 'error' });
      navigate('/');
    } else if (!appTokenIsValid) {
      localStorage.clear();
      // toast(`🚫 Oops! Your Subscription Has Been Expire.Please contact support for help! 😕`, { variant: 'error' });
      navigate('/');
    }
    if (!isSuperAdminEnabled || (isSuperAdmin && !isSuperAdminEnabled) || (!isSuperAdmin && !isUserEnabled)) {
      localStorage.clear();
      // toast(`🚫 Oops! You don't have permission to access this feature. Please contact support for help! 😕`, {
      //   variant: 'error'
      // });
      navigate('/');
    }
  }, [pathname]);

  return children;
};